import axios from 'axios'

// state
export const state = {
  isSportsLoading: false,
  selectedSportId: null,
  all: [],
}

// getters
export const getters = {
  getSelectedSport: ({ all, selectedSportId }) => selectedSportId && all.find(({ id }) => id === selectedSportId),
}
// mutations
export const mutations = {
  fetchSportsStarted(state) {
    state.isSportsLoading = true
  },
  fetchSportsSuccess(state, sports) {
    state.all = sports
    state.isSportsLoading = false

    if (!state.selectedSport && sports.length) {
      state.selectedSportId = sports[0].id
    }
  },
  fetchSportsFailed(state) {
    state.isSportsLoading = false
  },
  switchSelectedSport(state, { sportId }) {
    state.selectedSportId = sportId
  },
}
// actions
export const actions = {
  async fetchSports({ commit, state: { all } }) {
    if (all.length) {
      return all
    }
    let sports = null
    try {
      commit('fetchSportsStarted')
      sports = await axios.get('sports')
      commit('fetchSportsSuccess', sports)
    } catch (e) {
      commit('fetchSportsFailed')
    }
    return sports
  },
  async switchSelectedSport({ commit }, { sportId }) {
    commit('switchSelectedSport', { sportId })
  },
}
